<div class="content-app">
    <div class="row">
        <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
            <div class="card mt-2 mb-2">
                <div class="card-body">
                    <h5 class="mt-0 mb-2 text-primary">
                        <i class="fa-solid fa-tags"></i>   
                        Profesionales independientes
                    </h5>
                    <div>
                        <button type="button" class="btn btn-outline-primary me-2 mb-2">
                            <i class="fa-solid fa-briefcase"></i>
                            Todos
                            <span class="badge rounded-pill text-bg-primary">
                                {{totalProfessionals}}
                            </span>
                        </button>
                        <!-- <button type="button" class="btn btn-outline-primary me-2 mb-2">
                            <i class="fa-solid fa-calendar-week"></i>
                            Recientes esta semana
                            <span class="badge rounded-pill text-bg-primary">
                                {{experiencedProfessionals}}
                            </span>
                        </button>
                        <button type="button" class="btn btn-outline-primary me-2 mb-2">
                            <i class="fa-solid fa-user-tie"></i>
                            2 años de experiencia
                            <span class="badge rounded-pill text-bg-primary">
                                {{experiencedProfessionals}}
                            </span>
                        </button> -->
                        <!-- <button type="button" class="btn btn-outline-primary me-2 mb-2">
                            <i class="fa-regular fa-star"></i>
                            Con alta afinidad
                            <span class="badge rounded-pill text-bg-primary">
                                1
                            </span>
                        </button> -->
                    </div>
                    <hr class="mt-3 mb-3" />
                    <div class="row">
                        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label>Tipo de Tarifa</label>
                                <app-dropdown
                                    [options]="chargeTypes"
                                    [placeholder]="'Seleccionar tipo de tarifa'"
                                    [formControl]="chargeTypeControl"
                                ></app-dropdown>
                                <!-- <div class="row mt-2">
                                    <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                                        <div class="form-check mb-2">
                                            <input class="form-check-input" type="checkbox" [(ngModel)]="uiFilters.hourlyRate" id="hourlyRate">
                                            <label class="form-check-label" for="hourlyRate">
                                                Costo por hora
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                                        <div class="form-check mb-2">
                                            <input class="form-check-input" type="checkbox" [(ngModel)]="uiFilters.projectRate" id="projectRate">
                                            <label class="form-check-label" for="projectRate">
                                                Costo por obra
                                            </label>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label>Rango de Tarifa</label>
                                <div class="row">
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                        <div class="input-group mb-2">
                                            <span class="input-group-text">Desde</span>
                                            <input type="number" min="0" class="form-control" [(ngModel)]="uiFilters.minRate">
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                        <div class="input-group mb-2">
                                            <span class="input-group-text">Hasta</span>
                                            <input type="number" min="0" class="form-control" [(ngModel)]="uiFilters.maxRate">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12 text-end">
                            <div class="form-group mb-3 d-flex align-items-end h-100">
                                <div class="w-100">
                                    <button type="button" class="btn btn-outline-secondary me-2" (click)="clearFilters()">
                                        <i class="fa-solid fa-broom"></i> Limpiar
                                    </button>
                                    <button type="button" class="btn btn-primary" (click)="applyFilters()">
                                        <i class="fa-solid fa-filter"></i> Aplicar Filtros
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                            <h6 class="mt-0 mb-2">
                                Características del profesional
                            </h6>
                            <div class="row">
                                <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="CaracteristicasProfesional1">
                                        <label class="form-check-label" for="CaracteristicasProfesional1">
                                            Disponible para Viajar
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="CaracteristicasProfesional2">
                                        <label class="form-check-label" for="CaracteristicasProfesional2">
                                            Permiso de Trabajo
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="CaracteristicasProfesional3">
                                        <label class="form-check-label" for="CaracteristicasProfesional3">
                                            Seguro de vehículo
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="CaracteristicasProfesional4">
                                        <label class="form-check-label" for="CaracteristicasProfesional4">
                                            Bilingüe
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="CaracteristicasProfesional5">
                                        <label class="form-check-label" for="CaracteristicasProfesional5">
                                            Con certificaciones
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
            <div class="position-relative h-100">
                <div class="search-panel">
                    <app-search
                        [typeSearch]="'Freelancer'"
                    ></app-search>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="content-app">
    <br />
    <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <h5 class="mt-0 mb-2">
                <i class="fa-solid fa-user-tie"></i>
                Profesionales independientes
            </h5>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
        </div>
    </div>
    <div class="row">
        <ng-container *ngFor="let item of profesionals">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12">
                <a *ngIf="item.resumeId" [routerLink]="['/home/freelancer-detail', item.id, item.resumeId]" class="text-decoration-none">
                    <div class="card card-shop mb-3">
                        <div class="card-img-top">
                            <img [src]="item.foto" class="img-fluid" alt="foto" style="height: 200px; width: 100%; object-fit: cover;" />
                        </div>
                        <div class="card-body position-relative">
                            <!-- Badge de vistas en la esquina superior derecha -->
                            <span class="badge bg-light text-dark position-absolute top-0 end-0 mt-2 me-2 d-flex align-items-center">
                                <i class="fa-regular fa-eye me-1"></i>
                                {{ getViewCount(item.id) }}
                            </span>
                            <p class="mt-0 mb-0 text-left text-small">
                                <i class="fa-regular fa-clock"></i>
                                {{ item.experiencia }} | <i class="fa-solid fa-tag"></i> {{ item.price }}
                            </p>
                            <h5 class="mt-0 mb-0 text-primary">
                                {{ item.profesional }}
                            </h5>
                            <p class="mt-0 mb-0 text-left">
                                {{ item.nombreCompleto }}
                            </p>
                        </div>
                    </div>    
                </a>
                <div *ngIf="!item.resumeId" class="card card-shop mb-3">
                    <div class="card-img-top">
                        <img [src]="item.foto" class="img-fluid" alt="foto" style="height: 200px; width: 100%; object-fit: cover;" />
                    </div>
                    <div class="card-body position-relative">
                        <!-- Badge de vistas en la esquina superior derecha -->
                        <span class="badge bg-light text-dark position-absolute top-0 end-0 mt-2 me-2 d-flex align-items-center">
                            <i class="fa-regular fa-eye me-1"></i>
                            {{ getViewCount(item.id) }}
                        </span>
                        <p class="mt-0 mb-0 text-left text-small">
                            <i class="fa-regular fa-clock"></i>
                            {{ item.experiencia }} | <i class="fa-solid fa-tag"></i> {{ item.price }}
                        </p>
                        <h5 class="mt-0 mb-0 text-primary">
                            {{ item.profesional }}
                        </h5>
                        <p class="mt-0 mb-0 text-left">
                            {{ item.nombreCompleto }}
                        </p>
                        <div class="mt-2">
                            <span class="badge bg-secondary">Perfil no disponible</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>